export default {
    loading(state) {
        return state.loading + state.products.loading;
    }
}